import { Component, OnInit } from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {Title} from '@angular/platform-browser';

@Component({
  selector: 'app-registration',
  templateUrl: './registration.component.html',
  styleUrls: ['./registration.component.scss']
})
export class RegistrationComponent implements OnInit {

  viewtab: 'desktop' | 'web' | 'allinone' | 'none' = 'desktop';
  hover: 'desktop' | 'web' | 'allinone' | 'none' = 'desktop';
  isProcessing = false;

  constructor(private activeRoute: ActivatedRoute, private title: Title) {
    window.location.href = 'https://www.kadeck.com';
    this.title.setTitle("Get started with KaDeck");
    this.activeRoute.queryParamMap.subscribe(value => {
      if (value.has('tab')) {
        this.viewtab = value.get('tab') as ('desktop' | 'web' );
      } else {
        this.viewtab = 'none';
      }
    });
  }

  ngOnInit(): void {
  }

  openContact(){
    window.open('https://www.xeotek.com/kadeck/kadeck-request/', '_blank');
    // document.location.href="https://www.xeotek.com/";
  }

}
